import { render, staticRenderFns } from "./HotelsMapCard.vue?vue&type=template&id=2122270f"
import script from "./HotelsMapCard.vue?vue&type=script&lang=js"
export * from "./HotelsMapCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotelsCarousel: require('/home/forge/farescraper.com/components/HotelsCarousel.vue').default})
